import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HowWeWorkVideoSection from './components/HowWeWorkVideoSection';
import BrandPhilosophySection from './components/BrandPhilosophySection';

export default function HowWeWorkPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background-50">
        <HowWeWorkVideoSection />
        <BrandPhilosophySection />
      </main>
      <Footer />
    </>
  );
}